import apiUrl from '../../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'ebn-tracking',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      searchType: 'bag',
      bagNumber: '',
      awbNumber: '',
      searchResults: [],
      isSearchLoading: false,
      searchAttempted: false
    }
  },
  computed: {},
  mounted() {},
  methods: {
    async onSearchSubmit() {
      // Manual validation based on search type
      const searchValue = this.searchType === 'bag' ? this.bagNumber.trim() : this.awbNumber.trim();
      
      if (!searchValue) {
        this.$alertify.error(`Please enter ${this.searchType === 'bag' ? 'bag number' : 'AWB number'}`);
        return false;
      }
      
      this.searchEBNTracking();
    },

    searchEBNTracking() {
  const searchValue = this.searchType === 'bag' ? this.bagNumber.trim() : this.awbNumber.trim();
  
  if (!searchValue) {
    this.$alertify.error(`Please enter ${this.searchType === 'bag' ? 'bag number' : 'AWB number'}`);
    return;
  }

  this.isSearchLoading = true;
  this.searchResults = [];
  this.searchAttempted = true;

  const queryParam = this.searchType === 'bag' 
    ? `bagNumber=${searchValue}` 
    : `parentAwb=${searchValue}`;

  axios({
    method: 'GET',
    url: `${apiUrl.api_url_hubops}getEBNPartBTrackingLogs?${queryParam}`,
    headers: {
      'authorization': 'authkey xB84JJ89Hd25',
    }
  })
  .then(result => {
    this.isSearchLoading = false;
    
    if (result.data.ResultCode == 100) {
      const logs = result.data.ResponseData || [];
      const shipmentDetails = this.extractShipmentDetails(logs);
      
      this.searchResults = shipmentDetails;
      this.showSearchResultMessage(shipmentDetails);
    } else {
      this.$alertify.error(result.data.ReturnMessage || 'Failed to fetch EBN logs');
    }
  })
  .catch(error => {
    this.isSearchLoading = false;
    console.error('EBN tracking search error:', error);
    this.$alertify.error('Error fetching tracking details');
  });
},

extractShipmentDetails(logs) {
  const shipmentDetails = [];
  
  logs.forEach(log => {
      const identifier = this.searchType === 'bag'
        ? (log.bagNumber || '-')
        : (log.parentAwb || log.bagNumber || '-');
    const status = log.status || '-';
    const errorMessage = log.errorMessage;
    const requestTime = log.requestTime ? new Date(log.requestTime).toLocaleString() : '-';
    const createdDate = log.createdDate ? new Date(log.createdDate).toLocaleString() : '-';
    const createdDateRaw = log.createdDate ? new Date(log.createdDate) : null;
    const apiName = log.apiName || '-';
    
    // Normalize responseData - handle both object with data array and direct array
    let dataArray = null;
    
    if (log.responseData) {
      if (Array.isArray(log.responseData)) {
        // Case 2: responseData is directly an array
        dataArray = log.responseData;
      } else if (log.responseData.data && Array.isArray(log.responseData.data)) {
        // Case 1: responseData is an object with data property
        dataArray = log.responseData.data;
      }
    }
    
    if (dataArray && dataArray.length > 0) {
      // Process each EBN record
      dataArray.forEach(item => {
        shipmentDetails.push({
          identifier: identifier,
          shippingId: item.shippingid || log.parentAwb || '-',
          ewayBillNo: item.ewayBillNo || '-',
          ebnCode: item.ebnCode || '-',
          ebnMessage: item.ebnMessage || '-',
          vehicleNo: item.vehicleNo || '-',
          invoiceNo: item.invoiceNo || '-',
          validUpTo: item.validupTo || '-',
          status: status,
          apiName: apiName,
          requestTime: requestTime,
          createdDate: createdDate,
          createdDateRaw: createdDateRaw,
          errorMessage: errorMessage || null
        });
      });
    } else {
      // No responseData or failed request - show error details
      shipmentDetails.push({
        identifier: identifier,
        shippingId: log.parentAwb || '-',
        ewayBillNo: '-',
        ebnCode: '-',
        ebnMessage: errorMessage || 'No response data',
        vehicleNo: '-',
        invoiceNo: '-',
        validUpTo: '-',
        status: status,
        apiName: apiName,
        requestTime: requestTime,
        createdDate: createdDate,
        createdDateRaw: createdDateRaw,
        errorMessage: errorMessage
      });
    }
  });
  
  // Keep only the latest log per shippingId based on createdDate
  const latestByShipping = {};
  shipmentDetails.forEach(item => {
    const key = item.shippingId;
    if (!latestByShipping[key] || (item.createdDateRaw && latestByShipping[key].createdDateRaw && item.createdDateRaw > latestByShipping[key].createdDateRaw)) {
      latestByShipping[key] = item;
    }
  });
  const filtered = Object.values(latestByShipping);

  // Sort by createdDate descending
  filtered.sort((a, b) => {
    if (a.createdDateRaw && b.createdDateRaw) {
      return b.createdDateRaw - a.createdDateRaw;
    } else if (a.createdDateRaw) {
      return -1;
    } else if (b.createdDateRaw) {
      return 1;
    }
    return 0;
  });
  
  return filtered;
},

showSearchResultMessage(shipmentDetails) {
  if (shipmentDetails.length > 0) {
    const errorCount = shipmentDetails.filter(s => 
      s.status === 'failed' || s.errorMessage
    ).length;
    const successCount = shipmentDetails.filter(s => s.status === 'success').length;
    
    this.$alertify.success(
      `Found ${shipmentDetails.length} record(s) - ${successCount} successful, ${errorCount} failed`
    );
  } else {
    this.$alertify.success('No records found');
  }
},


    
    resetSearch() {
      this.bagNumber = '';
      this.awbNumber = '';
      this.searchResults = [];
      this.searchAttempted = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/EBNTracking/EBNTracking.js